import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalesActivityReport extends Layout {
    checkboxIncludeRemarks: Checkbox;
    checkboxPageBreak: Checkbox;
    excludabletextboxActivity: ExcludableTextbox;
    excludabletextboxCustomers: ExcludableTextbox;
    excludabletextboxOperationsUser: ExcludableTextbox;
    excludabletextboxSalesManager: ExcludableTextbox;
    excludabletextboxSalesperson: ExcludableTextbox;
    sourceSalesActivityReport: DataSource;
    textboxActionDate: Textbox;
    textboxActivityType: Textbox;
    textboxGroupBy: Textbox;
    textboxProspectType: Textbox;
    textboxSortBy: Textbox;
}
